import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Stack from '@mui/material/Stack';
import ListItemText from '@mui/material/ListItemText';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { FormAttachment } from 'types/appointment';
import { useCallback } from 'react';

interface Props extends FormAttachment {
    error?: string;
    onDelete: (id: string) => void;
    onView: (id: string) => void;
}

const itemStyles = {
    '& .MuiListItemText-secondary': {
        color: 'error.main',
    },
};
export const AppointmentAttachmentItem = ({ id, fileName, error, onDelete, onView }: Props) => {
    const deleteHandler = useCallback(() => onDelete(id), [id, onDelete]);
    const viewHandler = useCallback(() => onView(id), [id, onView]);

    return (
        <ListItem
            secondaryAction={
                <Stack direction="row">
                    <IconButton aria-label="view" onClick={viewHandler}>
                        <RemoveRedEyeRoundedIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={deleteHandler}>
                        <DeleteOutlineRoundedIcon color="error" />
                    </IconButton>
                </Stack>
            }
        >
            <ListItemIcon>
                <ImageOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={fileName} secondary={error} sx={itemStyles} />
        </ListItem>
    );
};
